<template>
  <div class="editor">
    <div class="source" @keydown.tab.prevent="tabber" @keyup="update" spellcheck="false" contenteditable></div>
  </div>
</template>

<script>

export default {

  name: 'editor',

  mounted: function () {

    var self = this
    window.addEventListener('message', function(evt) {
      switch(evt.data.msg) {
        case 'source':
        self.setContent(evt.data.data)
        break
      }
    }, false)

    var title = document.querySelector('title')
    title.textContent = 'Score Editor'

    this.$root.$on('setTemplate', source => {
      this.setContent(source)
      this.post(source)
    })

  },

  destroyed: function() {

    this.$root.$odd('setTemplate')

  },

  methods: {

    update: function (evt) {
      this.post(evt.target.textContent)
    },

    tabber: function (evt) {
      this.insertTextAtCursor('\t')
    },

    insertTextAtCursor: function(text) {
      var range
      var sel = window.getSelection()
      if (sel.rangeCount) {
        range = sel.getRangeAt(0)
        range.deleteContents()
        range.insertNode(document.createTextNode(text))
      }
    },

    post: function (source) {
      window.opener.postMessage({ msg: 'convert', data: source }, '*');
    },

    setContent: function (source) {
      document.querySelector('div.source').textContent = source
    }

  }

}

</script>

<style scoped>

.editor {
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}

.source {
  font-family: 'Cousine', monospace;
  font-size: 10pt;
  margin: 1em;
  padding: 0;
  line-height: 1.3em;
  outline: none;
  tab-size: 24;
  overflow: auto;
  word-wrap: normal;
  white-space: pre;
}

</style>
